// eslint-disable-next-line import/named
import { createRoute, redirect } from "@tanstack/react-router";

import VitaloraAgentsRouting from "./routingView";

import PendingComponent from "../../components/PendingComponent";
import { isDemoEnterprise } from "../../utils/auth";
import { authLayoutRoute } from "../auth-layout/route";

export const vitaloraAgentsRoutingRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: "agents/routing",
  beforeLoad() {
    if (!isDemoEnterprise()) {
      throw redirect({ to: "/" });
    }
  },
  component: VitaloraAgentsRouting,
  pendingComponent: PendingComponent,
});
